import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { i18nReducer } from 'react-redux-i18n';

import recorders from 'reducers/recorders';
import track from 'reducers/track';
import tracks from 'reducers/tracks';
import folders from 'reducers/folders';
import recorderCyclo from 'reducers/recorderCyclo';
import calibration from 'reducers/calibration';
import calibrations from 'reducers/calibrations';
import trackUploadingState from 'reducers/trackUploadingState';
import realtimePlayback from 'reducers/realtimePlayback';
import supervisionData from 'reducers/supervisionData';
import supervisionParams from 'reducers/supervisionParams';
import supervisionCharts from 'reducers/supervisionCharts';
import webSockets from 'reducers/webSockets';
import settings from 'reducers/settings';
import recorderTemplates from 'reducers/recorderTemplates';
import trackTemplate from 'reducers/trackTemplate';
import trackTemplates from 'reducers/trackTemplates';
import trackEvents from 'reducers/trackEvents';
import trackFilter from 'reducers/trackFilter';
import trackStatistics from 'reducers/trackStatistics';
import user from 'reducers/user';
import users from 'reducers/users';

const appReducer = combineReducers({
  recorders,
  track,
  tracks,
  folders,
  recorderCyclo,
  calibration,
  calibrations,
  trackUploadingState,
  realtimePlayback,
  supervisionData,
  supervisionCharts,
  supervisionParams,
  webSockets,
  trackFilter,
  recorderTemplates,
  trackTemplate,
  trackTemplates,
  trackEvents,
  trackStatistics,
  settings,
  router: routerReducer,
  i18n: i18nReducer,
  user: user,
  users: users
});

const rootReducer = (state, action) => {
  if (action.type === 'POST_USER_LOGOUT_COMPLETE') {
    const { i18n, router } = state;
    state = { i18n, router };
  }

  return appReducer(state, action)
};

export default rootReducer;
